var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.3 64c-1.15 0-2.29-.45-3.14-1.35l-22.16-23.42-22.15 23.42c-1.64 1.74-4.38 1.81-6.11.17-1.74-1.64-1.82-4.38-.18-6.12l25.3-26.74c.82-.86 1.95-1.35 3.14-1.35 1.19 0 2.32.49 3.14 1.35l25.3 26.74c1.64 1.74 1.57 4.47-.17 6.11-.84.8-1.91 1.19-2.97 1.19z",
    fill: "#010101"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57.3 35.39c-1.15 0-2.29-.45-3.14-1.35l-22.16-23.42-22.15 23.42c-1.64 1.74-4.38 1.81-6.11.17-1.74-1.64-1.82-4.38-.18-6.12l25.3-26.74c.82-.86 1.95-1.35 3.14-1.35 1.19 0 2.32.49 3.14 1.35l25.3 26.74c1.64 1.74 1.57 4.47-.17 6.11-.84.8-1.91 1.19-2.97 1.19z",
    fill: "#010101"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.5878dc7e24c038cec50c12114dcd37b0.svg";
export { ForwardRef as ReactComponent };